import React from "react";
import "./Home.css";
import logo from "./logo.png";
import Navbar from "./Navbar";
import Bannervid from "./Bannervid.mp4";

const Home = () => {
  return (
    <>
      <Navbar isHome={true} />
      <div className="home-container">
        <video autoPlay loop muted playsInline className="background-video">
          <source src={Bannervid} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="news-ticker">
          <div className="ticker-content">
            <span className="ticker-item">
              <h1>Widest Network in Pakistan</h1>
            </span>
            <span className="ticker-item">
              <h1>
                <img src={logo} alt="" className="news-logo" />
              </h1>
            </span>
            <span className="ticker-item">
              <h1>پراپرٹی کی تعبیر سے تکمیل تک</h1>
            </span>
            <span className="ticker-item">
              <h1>
                <img src={logo} alt="" className="news-logo" />
              </h1>
            </span>
            <span className="ticker-item">
              <h1>یہ کہانی آج کی نہیں ، یہ قصہ ہے تہائی صدی کا</h1>
            </span>
            <span className="ticker-item">
              <h1>
                <img src={logo} alt="" className="news-logo" />
              </h1>
            </span>
            
            
            {/* Duplicate the items to ensure seamless scroll */}
            <span className="ticker-item">
              <h1>Widest Network in Pakistan</h1>
            </span>
            <span className="ticker-item">
              <h1>
                <img src={logo} alt="" className="news-logo" />
              </h1>
            </span>
            <span className="ticker-item">
              <h1>پراپرٹی کی تعبیر سے تکمیل تک</h1>
            </span>
            <span className="ticker-item">
              <h1>
                <img src={logo} alt="" className="news-logo" />
              </h1>
            </span>
            <span className="ticker-item">
              <h1>یہ کہانی آج کی نہیں ، یہ قصہ ہے تہائی صدی کا</h1>
            </span>
            <span className="ticker-item">
              <h1>
                <img src={logo} alt="" className="news-logo" />
              </h1>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
